import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicePage from './pages/ServicePage';
import CartPage from './pages/CartPage';
import { carListings, bikeListings, applianceListings, pgListings } from './mock';
import { Car, Bike, Home, Building2 } from 'lucide-react';

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route
                path="/car"
                element={
                  <ServicePage
                    title="Car Rental"
                    listings={carListings}
                    icon={Car}
                  />
                }
              />
              <Route
                path="/bike"
                element={
                  <ServicePage
                    title="Bike Rental"
                    listings={bikeListings}
                    icon={Bike}
                  />
                }
              />
              /*<Route
                path="/appliance"
                element={
                  <ServicePage
                    title="Appliance Rental"
                    listings={applianceListings}
                    icon={Home}
                  />
                }
              />
              <Route
                path="/pg"
                element={
                  <ServicePage
                    title="PG/Accommodation"
                    listings={pgListings}
                    icon={Building2}
                  />
                }
              /> */
              <Route path="/cart" element={<CartPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
